import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from './http-client.service';
import { FacilityBookingConfigurationsDto, VenueDto } from '@core/models/dto/FacilityBookingConfigurationsDto';
import { OnlineBookingConfigurationsDto } from '@core/models/dto/OnlineBookingConfigurationsDto';

@Injectable({
  providedIn: 'root',
})
export class BookingConfigurationService {
  private httpClient: HttpClientService = inject(HttpClientService);

  getOnlineBookingConfigurations(): Observable<OnlineBookingConfigurationsDto> {
    return this.httpClient.get('BookingInputConfiguration/Online');
  }

  getFacilityBookingConfigurations(): Observable<FacilityBookingConfigurationsDto> {
    return this.httpClient.get('BookingInputConfiguration/Facility');
  }

  getFacilityCountriesByServiceType(serviceTypeId: number): Observable<VenueDto[]> {
    return this.httpClient.get(`BookingInputConfiguration/Facility/servicetype/${serviceTypeId}`);
  }
}
